<template>
  <PrivacyPolicyBY v-if="locale.currentCountry === COUNTRY_CODE.BY" />
  <PrivacyPolicyKZ v-else-if="locale.currentCountry === COUNTRY_CODE.KZ" />
  <PrivacyPolicyKG v-else-if="locale.currentCountry === COUNTRY_CODE.KG" />
  <PrivacyPolicyCIS v-else-if="locale.currentCountry !== COUNTRY_CODE.RU" />
  <PrivacyPolicyRU v-else />
</template>

<script setup lang="ts">
import { COUNTRY_CODE } from '~/core/i18n'
import { generatePageMetaLinks } from '~/core/seo'
import PrivacyPolicyRU from '~/features/privacy-policy/PrivacyPolicyRU.vue'
import PrivacyPolicyBY from '~/features/privacy-policy/PrivacyPolicyBY.vue'
import PrivacyPolicyKZ from '~/features/privacy-policy/PrivacyPolicyKZ.vue'
import PrivacyPolicyKG from '~/features/privacy-policy/PrivacyPolicyKG.vue'
import PrivacyPolicyCIS from '~/features/privacy-policy/PrivacyPolicyCIS.vue'

definePageMeta({
  layout: 'sidebar',
})

const locale = useAppLocale()

useHead({
  link: generatePageMetaLinks(),
})
</script>

<style lang="scss">
.privacy-policy {
  & li {
    margin: 0 0 16px;
    list-style-type: none;
  }

  & ol {
    counter-reset: list1;
    margin: 0;
    padding-left: 0;

    & ol {
      margin: 16px 0;
    }

    & > li::before {
      counter-increment: list1;
      content: counter(list1) ". ";
    }

    // stylelint-disable-next-line
    & ol {
      counter-reset: list2;

      & > li::before {
        counter-increment: list2;
        content: counter(list1) "." counter(list2) ". ";
      }

      & ol {
        counter-reset: list3;

        & > li::before {
          counter-increment: list3;
          content: counter(list1) "." counter(list2) "." counter(list3) ". ";
        }
      }
    }
  }
}
</style>
